var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgSuccess = function SvgSuccess(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Success' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,46 C11.869,46 2,36.131 2,24 C2,11.869 11.869,2 24,2 C36.131,2 46,11.869 46,24 C46,36.131 36.131,46 24,46 M24,0 C10.767,0 0,10.767 0,24 C0,37.233 10.767,48 24,48 C37.233,48 48,37.233 48,24 C48,10.767 37.233,0 24,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1802 31.0781 14.8312 22.7281 13.4172 24.1421 23.6092 34.3341 34.9902 14.6341 33.2582 13.6341"
  }));
};
SvgSuccess = pure(SvgSuccess);
SvgSuccess.displayName = 'SvgSuccess';
export default SvgSuccess;